import { EventEmitter } from "@angular/core";

export var DATE_REGEX = "dd/MM/yyyy, hh:mm a";
export var NAME_REGEX = "^[a-zA-Z ]*$";

export var MOBILE_REGEX = "^[1-9][0-9]*$";

export var EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var SPACE_REGEX = /((?!.*[\s])(?=.*[A-Z])(?=.*\d))/;
export var Percentage_REGEX = /^([1-9]|[1-9][0-9]|100)$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#.()^+\-/|`'~{}:><=";_\[\]\\])[A-Za-z\d@$!%*?&#.()^+\-/|`'~{}:><=";_\[\]\\]{6,16}$/;

export let URL_REGEX =
  /^(http?|ftp|https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(app|com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;

export let facebook_REGEX =
  /((https):\/\/)(www\.)facebook\.com\/[a-zA-Z0-9.]{1,}/;
export let instagram_REGEX =
  /(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.]{1,30}\/?/;
export let twitter_REGEX =
  /(https?:\/\/)?(www\.)?twitter\.com\/[A-Za-z0-9_]{5,15}(\?(\w+=\w+&?)*)?/;
export let linkedIn_REGEX =
  /[(https:\/\/www\.linkedin.com)]{20}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/=]*)+/;
export let youtube_REGEX =
  /(?:(?:https?:\/\/)(?:www)?\.?(?:youtu\.?be)(?:\.com)?\/(?:.*[=/])*)([^= &?/\r\n]{8,11})/;
export let payLink =
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
export var LIMIT = 10;

export var MAX_SIZE = 3;

export const noNumberRegExp = /^[a-zA-Z ]*$/;
export const NOT_ALLOW_SPACES = /^([0-9]+)$/;
export const letterswithspace = /^[a-zA-Z][a-zA-Z\s]*$/;
export const alphaSpecialCharacters = /^[a-zA-Z_!@#$&()\\-`.+,/\"]*$/;

export const COLORS = [
  { color: "tag tag-default" },
  { color: "tag tag-azure" },
  { color: "tag tag-pink" },
  { color: "tag tag-gray" },
  { color: "tag tag-primary" },
  { color: "tag tag-secondary" },
  { color: "tag tag-success" },
  { color: "tag tag-cyan" },
  { color: "tag tag-orange" },
];

export function multiplyArray(arr: any, length: any) {
  return Array.from({ length }, () => arr).flat();
}

export function _clone(object: any): any {
  return JSON.parse(JSON.stringify(object));
}

export function _removeNullKeys(obj: any): any {
  Object.keys(obj).forEach((key) => obj[key] == null && delete obj[key]);
  return obj;
}

export function _dateTime24HoursList(): any {
  const currentDate = new Date();
  const dateTimeArray = [];
  for (let i = 0; i < 24; i++) {
    const hourDateTime = new Date(currentDate);
    hourDateTime.setHours(i, 0, 0, 0);
    dateTimeArray.push(hourDateTime);
  }
  return dateTimeArray;
}

let timerObject: any;
export const timerCount: EventEmitter<any> = new EventEmitter();
export function timer(time: any): any {
  clearInterval(timerObject); // Clear any existing timer
  let textSec: any = "0";
  let statSec: number = 30;
  timerObject = setInterval(() => {
    time.seconds--;
    if (statSec != 0) statSec--;
    else statSec = 59;
    if (statSec < 10) {
      textSec = "0" + statSec;
    } else textSec = statSec;
    if (time.seconds == 0) {
      clearInterval(timerObject);
      timerCount.emit(null);
    } else timerCount.emit(`${textSec}`);
  }, 1000);
}

export function _clearInterval(): any {
  clearInterval(timerObject);
}

export function modifyAppliedFiltersData(
  filtersList: any,
  appliedFilters: any
) {
  return filtersList.reduce((acc: any, curr: any) => {
    const matchingChildren = curr.children.filter((child: any) =>
      appliedFilters.includes(child.name)
    );
    if (matchingChildren.length > 0) {
      acc[curr.name.toLowerCase()] = matchingChildren.map(
        (child: any) => child.sId
      );
    }
    return acc;
  }, {});
}

export function phoneNumberPipe(value: any) {
  // Eg. 4444-4444
  let phone: any;
  if (value != null) {
    const newVal = value.toString();
    const first = newVal.substring(0, 4);
    const last = newVal.substring(4, 8);
    phone = first + "-" + last;
  }
  return phone;
}

export const menuItems: any = [
  {
    path: "dashboard",
    title: "Dashboard",
    icon: "ic_dashboard_inactive.svg",
    selectedIcon: "ic_dashboard_inactive.svg",
    type: "link",
    Menusub: false,
    selected: false,
    module: [],
  },
  {
    path: "licences",
    title: "Licences",
    icon: "ic_licence_inactive.svg",
    selectedIcon: "ic_licence_active.svg",
    type: "link",
    Menusub: false,
    selected: false,
    module: [],
  },
  {
    path: "arms",
    title: "Arms",
    icon: "ic_arms_inactive.svg",
    selectedIcon: "ic_arms_inactive.svg",
    type: "link",
    Menusub: false,
    selected: false,
    module: [],
  },
  {
    path: "ammunition",
    title: "Ammunition",
    icon: "ic_ammunation_inactive.svg",
    selectedIcon: "ic_ammunation_inactive.svg",
    type: "link",
    Menusub: false,
    selected: false,
    module: [],
  },
  {
    path: "drafts/licences",
    title: "Drafts",
    icon: "ic_draft.svg",
    selectedIcon: "ic_draft.svg",
    type: "link",
    Menusub: false,
    selected: false,
    module: [],
  },
];
export const headingItems: any = [
  {
    path: "dashboard",
    title: "Dashboard",
    subTitle: "Hi John, Welcome back to web portal.",
    selected: false,
    page: "List",
  },
];

export const defaultTemplateObj = {
  agencyCode: "",
  formId: 1,
  isDefault: false,
};

export const licencesTableHeading: any = [
  { title: "Licences" },
  { title: "Expiry date" },
  { title: "Title" },
  { title: "Last name" },
  { title: "First name" },
  { title: "DOB" },
  { title: "Licence type" },
  { title: "Locality" },
  { title: "District" },
  { title: "ID type" },
  { title: "Action" },
];

export function convertNullToEmptyString(obj: any): any {
  if (obj === null) {
    return "";
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertNullToEmptyString(item));
  }

  if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = convertNullToEmptyString(obj[key]);
      return acc;
    }, {} as any);
  }

  return obj;
}

export const permissions = {
  NewLicence: false,
  EditLicenceDetails: false,
  RenewLicence: false,
  PermittoProcure: false,
  RegisteranArm: false,
  EditanArm: false,
  TransferanArm: false,
  ChangeStatusofArm: false,
  RegisterAmmunition: false,
  EditAmmunition: false,
  ChangeStatusofAmmunition: false,
  TransferAmmunition: false,
};

export const armsStatus: { [key: string]: string } = {
  "Registered": "Registered",
  "Stolen": "Stolen",
  "Lost": "Lost",
  "Case pending - held": "Case pending - held",
  "Case closed - returned": "Case closed - returned",
  "Destroyed": "Destroyed",
  "Held for destruction": "Held for destruction",
  "Imported": "Imported",
  "Under bond": "Under bond",
  "Exported": "Exported"
};

export const armsStatusCss: { [key: string]: string } = {
  "Registered": "status__registered",
  "Stolen": "status__stolen",
  "Lost": "status__lost",
  "Case pending - held": "status__pending",
  "Case closed - returned": "status__closed",
  "Destroyed": "status__destroyed",
  "Held for destruction": "status__destuction",
  "Imported": "status__imported",
  "Under bond": "status__underBond",
  "Exported": "status__exported"
};